import { render, staticRenderFns } from "./ControlPanelConfiguration.vue?vue&type=template&id=6e64b56f&scoped=true"
import script from "./ControlPanelConfiguration.vue?vue&type=script&lang=js"
export * from "./ControlPanelConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e64b56f",
  null
  
)

export default component.exports